<template>
  <div v-if="show_wallets" class="header__wallets">
    <div v-if="show_wallets" class="header__wallets__label">{{ $t("header.wallets") }}</div>
    <div class="header__wallets__item">
      <i class="icon icon-paid-points" name="header_currency_paid"></i>
      <span>{{ getWalletsState.hard }}</span>
    </div>

    <div class="header__wallets__item">
      <i class="icon icon-free-points" name="header_currency_free"></i>
      <span>{{ getWalletsState.soft }}</span>
    </div>

    <tippy :to="'header_currency_paid'" :arrow="true" :theme="'wf-bp'" :interactive="false">
      <p>{{ $t("header.tooltip.paid") }}</p>
    </tippy>

    <tippy :to="'header_currency_free'" :arrow="true" :theme="'wf-bp'" :interactive="false">
      <p>{{ $t("header.tooltip.free") }}</p>
    </tippy>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "HeaderWallets",
  data() {
    return {
      show_wallets: false,
    };
  },
  computed: {
    ...mapGetters("wallets", ["getWalletsState"]),
  },
  mounted() {
    this.$store.dispatch("wallets/getWalletsData").then(() => {
      this.show_wallets = true;
    });
  },
};
</script>
